"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Wrench, TriangleAlert, VolumeX, MoveDownRight, CircleCheck, ShieldCheck, Clock, ArrowRight } from "lucide-react";
const commonIssues = [{
  title: "Poor Body Alignment",
  desc: "Hips dropping or shoulders rotating too early, leading to inefficient power transfer and potential injury.",
  icon: TriangleAlert
}, {
  title: "Lack of Rhythm",
  desc: "Jerky movements or rushing through the transition phase, which disrupts the natural flow of the drill.",
  icon: VolumeX
}, {
  title: "Improper Footwork",
  desc: "Heels striking too hard or feet landing outside the center of gravity, causing balance issues.",
  icon: MoveDownRight
}];
const processSteps = [{
  value: "step-1",
  title: "1. Dynamic Mobility Phase",
  content: "Begin with leg swings and hip circles to lubricate the joints. Focus on a full range of motion without forcing the stretch, preparing the nervous system for high-intensity movement."
}, {
  value: "step-2",
  title: "2. Technical Form Drills",
  content: "Execute slow-motion repetitions of the primary movement. Pay close attention to hand placement and core engagement. Perform 3 sets of 10 reps with a focus on perfect execution."
}, {
  value: "step-3",
  title: "3. Progressive Loading",
  content: "Gradually increase the speed and resistance. Use light bands or bodyweight to simulate the full drill intensity while maintaining the technical integrity established in the previous step."
}, {
  value: "step-4",
  title: "4. Neural Activation",
  content: "Finish with short, explosive bursts of 3-5 seconds. This 'wakes up' the fast-twitch muscle fibers and ensures you are fully primed for the main training session or competition."
}];
const specifications = ["Core Stability", "Joint Lubrication", "Neural Priming", "Rhythm Control", "Injury Prevention"];
export default function DrillInstructions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: issuesRef,
    isVisible: isIssuesVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}